var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeartIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.54661 4.21941L7.99946 4.76775L7.45063 4.21892C6.05125 2.81954 3.78241 2.81954 2.38303 4.21892C0.983651 5.6183 0.983651 7.88714 2.38303 9.28652L7.64661 14.5501C7.84187 14.7454 8.15845 14.7454 8.35372 14.5501L13.6214 9.28554C15.0176 7.88152 15.02 5.61905 13.6204 4.21941C12.2185 2.81749 9.94853 2.81749 8.54661 4.21941Z",
    fill: "#4B4AD5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeartIcon);
export default __webpack_public_path__ + "static/media/heart-icon.5b0e8b386bcb3ee786ca3a148609c70d.svg";
export { ForwardRef as ReactComponent };